import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BtpayDirective } from './btpay/btpay.directive';

import { PanelLayoutModule } from './panel-layout/panel-layout.module';
import { QRCodeModule } from 'angularx-qrcode';
import { DecimalPricePipe, PricePipe } from './pipe/price.pipe';

import { LoginComponent } from './login/login.component';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { ButtonImageComponent } from './button-image/button-image.component';
import { CardBoxComponent } from './card-box/card-box.component';
import { OrderCardComponent } from './order-card/order-card.component';
import { KaskoCardComponent } from './kasko-card/kasko-card.component';
import { KaskoCardRateComponent } from './kasko-card-rate/kasko-card-rate.component';
import { KaskoCardFinComponent } from './kasko-card-fin/kasko-card-fin.component';
import { EstimateCardComponent } from './estimate-card/estimate-card.component';
import { CustomerCardComponent } from './customer-card/customer-card.component';
import { ShipmentCardComponent } from './shipment-card/shipment-card.component';
import { ErrorToastComponent } from './error-toast/error-toast.component';
import { ResetComponent } from './reset/reset.component';
import { FormInputErrorComponent } from './form-input-error/form-input-error.component';
import { QrcodeCardComponent } from './qrcode-card/qrcode-card.component';
import { SpinnerComponent } from './spinner/spinner.component';

import { CustomerNameComponent } from './customer-name/customer-name.component';
import { OrderDateComponent } from './order-date/order-date.component';
import { ButtonOrderViewComponent } from '../orders-in-progress/button-order-view/button-order-view.component';
import { ButtonShipmentViewComponent } from '../shipment-in-progress/button-shipment-view/button-shipment-view.component';

import { EstimateDaoService } from '../core/dao-service/estimate-dao.service';
import { CustomersDaoService } from '../core/dao-service/customers-dao.service';
import { OrdersDaoService } from '../core/dao-service/orders-dao.service';
import { SearchInputComponent } from './search-input/search-input.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PanelLayoutModule,
    RouterModule,
    QRCodeModule,
  ],
  exports: [
    PanelLayoutModule,
    CommonModule,
    ReactiveFormsModule,

    LoginComponent,
    VerifyAccountComponent,
    ResetComponent,
    CardBoxComponent,
    EstimateCardComponent,
    OrderCardComponent,
    KaskoCardComponent,
    KaskoCardFinComponent,
    KaskoCardRateComponent,
    CustomerCardComponent,
    QrcodeCardComponent,
    ShipmentCardComponent,
    SpinnerComponent,

    CustomerNameComponent,
    OrderDateComponent,
    ButtonOrderViewComponent,
    ButtonShipmentViewComponent,
    SearchInputComponent,

    ButtonImageComponent,
    ErrorToastComponent,
    FormInputErrorComponent,

    PricePipe,
    DecimalPricePipe,
    BtpayDirective,
  ],
  entryComponents: [
    CustomerNameComponent,
    OrderDateComponent,
    ButtonOrderViewComponent,
    ButtonShipmentViewComponent,
  ],
  declarations: [
    LoginComponent,
    VerifyAccountComponent,
    ResetComponent,
    CardBoxComponent,
    EstimateCardComponent,
    OrderCardComponent,
    KaskoCardComponent,
    KaskoCardFinComponent,
    KaskoCardRateComponent,
    CustomerCardComponent,
    QrcodeCardComponent,
    ShipmentCardComponent,
    SpinnerComponent,

    ButtonImageComponent,
    ErrorToastComponent,
    FormInputErrorComponent,

    CustomerNameComponent,
    OrderDateComponent,
    ButtonOrderViewComponent,
    ButtonShipmentViewComponent,
    SearchInputComponent,

    PricePipe,
    DecimalPricePipe,
    BtpayDirective,
  ],
  providers: [
    EstimateDaoService,
    CustomersDaoService,
    OrdersDaoService
  ]
})
export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts